"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEvmContractLogs = void 0;
var common_evm_utils_1 = require("moralis/common-evm-utils");
var resolvers_1 = require("../../../resolvers");
var useEvmContractLogs = function (request, fetchParams) {
    var _a = (0, resolvers_1.useResolverPaginated)({
        endpoint: 'evmApi/getContractLogs',
        operation: common_evm_utils_1.getContractLogsOperation,
        request: request,
        fetchParams: fetchParams,
    }), data = _a.data, error = _a.error, fetch = _a.fetch, isFetching = _a.isFetching;
    return {
        data: data === null || data === void 0 ? void 0 : data.data,
        cursor: data === null || data === void 0 ? void 0 : data.cursor,
        page: data === null || data === void 0 ? void 0 : data.page,
        pageSize: data === null || data === void 0 ? void 0 : data.pageSize,
        total: data === null || data === void 0 ? void 0 : data.total,
        error: error,
        fetch: fetch,
        /**
         * @deprecated use `fetch()` instead
         */
        refetch: function () { return fetch(); },
        isFetching: isFetching,
        /**
         * @deprecated use `isFetching` instead
         */
        isValidating: isFetching,
    };
};
exports.useEvmContractLogs = useEvmContractLogs;
//# sourceMappingURL=useEvmContractLogs.js.map